import React from 'react';

import "./SocialCard.css";

export default function SocialCard(props) {
  return  <div className="mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-card mdl-shadow--3dp">
    <div className="mdl-card__media">
      <img src={props.src} />
    </div>
    <div className="mdl-card__title">
        <h4 className="mdl-card__title-text">{props.name}</h4>
    </div>
    <div className="mdl-card__supporting-text">
      <span className="mdl-typography--font-light mdl-typography--subhead">Come see my resume and accomplishments.</span>
    </div>
    <div className="mdl-card__actions">
        <a className="portfolio-link mdl-button mdl-js-button mdl-typography--text-uppercase" href={props.url}>
          {props.name}
          <i className="material-icons">chevron_right</i>
        </a>
    </div>
  </div>
}


// WEBPACK FOOTER //
// ./src/SocialCard/SocialCard.js